import React from 'react';
import { Header, TabNavigation } from '../components';
import { useAppSelector } from '../services/store';
import { getShowDownloadAppBanner } from 'src/shared/redux-state/src';
import { useWindowWidth } from '../utilities/helpers';
type IProps = {
    fixedFooter?: boolean
    showLearningJourneyIcon?: boolean
}
const ChildrenLayout: React.FC<React.PropsWithChildren<IProps>> = ({ children, fixedFooter = false, showLearningJourneyIcon = false }) => {

    const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);
    const width = useWindowWidth();
    
    return (
        <div className={`main-wrapper bg-white container ${showDownloadAppBanner ? (width > 567 ? 'pd-t-86' : 'pd-t-92') : 'pd-t-50'} ${fixedFooter ? 'pd-b-70' : 'pd-b-20'}`}>
            <Header showLearningJourneyIcon={showLearningJourneyIcon} />
            {children}
            <TabNavigation />
        </div>
    );
};

export default ChildrenLayout;
